import React from "react";
import { Card } from "./Cards";
import { Section } from "./Sections";
import { RaceCard } from "./RaceCar";

function BovinDetails() {
  return (
 
  
      <div >
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center bg-black text-white py-4 rounded-lg mb-20">
          Soin, santé et bien-être des bovins
        </h2>
        {/* Présentation */}
        <Section title="Présentation">
          <p>
            Timide à ses débuts, l’élevage bovin en Côte d’Ivoire a connu un
            essor considérable après la crise alimentaire de 1972–1973. Il
            constitue aujourd’hui une source majeure de protéines animales.
          </p>

          <p>
            Cette activité est principalement concentrée dans le Nord et le
            Centre du pays. Malgré la présence des glossines (mouches tsé-tsé),
            certaines races locales comme le <strong>Baoulé</strong> et le{" "}
            <strong>N’dama</strong> résistent bien à la trypanosomiase.
          </p>

          <p>
            Pour améliorer la productivité, les éleveurs pratiquent souvent le
            métissage avec des zébus, réputés pour leur grande taille et leur
            rendement.
          </p>
        </Section>

        {/* Races */}
        <Section title="Races bovines élevées">
          <div className="grid md:grid-cols-2 gap-6">
            <RaceCard
              title="N’dama"
              content={[
                "Race taurine locale résistante à la trypanosomiase",
                "14% du cheptel ivoirien",
                "Taille : 113 cm (femelle), 116 cm (mâle)",
                "Poids adulte : 200–300 kg (vache), 450 kg (taureau)",
                "Présente au Centre et Nord-Ouest",
              ]}
            />

            <RaceCard
              title="Baoulé"
              content={[
                "Race taurine de petite taille",
                "37% du cheptel national",
                "Taille : environ 100 cm au garrot",
                "Poids adulte : 150–350 kg",
                "Tolérante à la trypanosomiase",
                "Présente au Centre et Nord-Est",
              ]}
            />

            <RaceCard
              title="Lagunaire"
              content={[
                "Race taurine en voie d’extinction",
                "Pelage pie-noire",
                "Gabarit inférieur au Baoulé",
                "Forte résistance à l’humidité",
                "Localisée au Sud forestier",
              ]}
            />

            <RaceCard
              title="Zébu"
              content={[
                "30% du cheptel ivoirien",
                "Principalement élevé au Nord",
                "Intolérant à la trypanosomiase",
                "Bonne adaptation aux longues marches",
                "Poids adulte : 300–400 kg",
                "Maturité sexuelle tardive",
              ]}
            />
          </div>
        </Section>

        {/* Types d’élevage */}
        <Section title="Types d’élevage bovin">
          <div className="grid md:grid-cols-3 gap-6">
            <Card title="Élevage traditionnel sédentaire">
              <ul className="list-disc list-inside space-y-2">
                <li>Troupeaux multi-propriétaires</li>
                <li>Gestion confiée à un bouvier</li>
                <li>Aucune intervention sanitaire</li>
                <li>Faibles performances</li>
              </ul>
            </Card>

            <Card title="Élevage traditionnel transhumant">
              <ul className="list-disc list-inside space-y-2">
                <li>Origine sahélienne</li>
                <li>Troupeaux de 150 à 500 têtes</li>
                <li>Majorité de zébus</li>
                <li>Soins sanitaires et complément minéral</li>
              </ul>
            </Card>

            <Card title="Élevage moderne">
              <ul className="list-disc list-inside space-y-2">
                <li>Ranches d’État et initiatives privées</li>
                <li>Alimentation contrôlée</li>
                <li>Suivi de la reproduction</li>
                <li>Spécialisation : lait ou embouche</li>
              </ul>
            </Card>
          </div>
        </Section>
      </div>
    
  );
}



export default BovinDetails;
